import AuthService from '../services/auth.service';
 
const user = JSON.parse(localStorage.getItem('user'));

const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    refreshToken({ commit }, user) {
      commit('refreshToken', user);
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    setIsMember({ commit }, isMember) {
      commit('setIsMember', isMember);
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.user = user;
      state.status.loggedIn = true;
    },
    loginFailure(state) {
      state.user = null;
      state.status.loggedIn = false;
    },
    refreshToken(state, user) {
      state.user = user;
      state.status.loggedIn = true;
    },
    logout(state) {
      state.user = null;
      state.status.loggedIn = false;
    },
  }
};
